import Button from 'core/modules/atoms/Button';
import Textarea from 'core/modules/atoms/Textarea';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const TextInputMode = ({ value, onChange, placeholder, wordCount, wordLimit, onOpenDialog, disabled, name }) => {
  const { t } = useTranslation(['chatbot']);
  const handleChange = (e) => {
    onChange(e.currentTarget.value);
  };

  return (
    <div className="text-input-mode">
      <div className="text-input-mode__textarea-wrapper">
        <Textarea name={name} placeholder={placeholder} onChange={handleChange} value={value} rows={2} disabled={disabled} />
      </div>

      <div className="text-input-mode__footer">
        <div>
          <Button
            text={t('chatbot:Choose from book')}
            size="large"
            color="transparent-primary"
            onClick={onOpenDialog}
            disabled={disabled}
            variant="inline"
            className="text-input-mode__choose-button"
          />
        </div>

        <div className="text-input-mode__counter">
          {t('chatbot:Word limit')}: {wordCount}/{wordLimit}
        </div>
      </div>
    </div>
  );
};

TextInputMode.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  wordCount: PropTypes.number.isRequired,
  wordLimit: PropTypes.number.isRequired,
  onOpenDialog: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  name: PropTypes.string,
};

TextInputMode.defaultProps = {
  disabled: false,
  placeholder: '',
  name: 'text-input',
  wordLimit: 2000,
};

export default TextInputMode;
